// Fatia S5b: situação das filas de trabalho (atualiza a cada 10 s).
import { num } from '@impulso/shared'
import { ErrorState, Loading, PageHead } from '../../ui'
import { AdminNav } from '../../features/admin/AdminNav'
import { useAdminQueues } from '../../features/admin/api'

const LANE: Record<string, string> = { default: 'Geral', sync: 'Sincronização', decisions: 'Decisões', actions: 'Ações nas plataformas', ai: 'IA', reports: 'Relatórios', notifications: 'Avisos' }
const COLS = ['waiting', 'active', 'delayed', 'failed', 'completed'] as const
const COL_LABEL = { waiting: 'Esperando', active: 'Rodando', delayed: 'Agendados', failed: 'Falharam', completed: 'Concluídos' }

export default function AdminQueues() {
  const q = useAdminQueues()
  return (
    <>
      <PageHead title="Filas" sub="Trabalhos em segundo plano por faixa. Atualiza sozinho a cada 10 segundos." />
      <AdminNav />
      {q.isLoading && <div className="card"><Loading lines={5} /></div>}
      {q.error && <ErrorState error={q.error} onRetry={() => q.refetch()} />}
      {q.data?.mode === 'inline' && <div className="callout">As filas estão no modo inline (desenvolvimento/testes): os trabalhos rodam na hora, sem fila.</div>}
      {q.data?.error && <div className="callout amber" role="alert">Não foi possível consultar as filas: {q.data.error}</div>}
      {q.data && q.data.mode === 'bullmq' && !q.data.error && (
        <div className="card flush">
          <div className="table-wrap">
            <table className="table stack-sm">
              <thead><tr><th>Faixa</th>{COLS.map((c) => <th key={c} className="right">{COL_LABEL[c]}</th>)}</tr></thead>
              <tbody>
                {Object.entries(q.data.lanes).map(([lane, c]) => (
                  <tr key={lane}>
                    <td className="strong">{LANE[lane] ?? lane}</td>
                    {COLS.map((col) => (
                      <td key={col} className="right" data-label={COL_LABEL[col]}>
                        <span className={col === 'failed' && (c[col] ?? 0) > 0 ? 'badge red' : ''}>{num(c[col] ?? 0)}</span>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  )
}
